import * as z from "zod/v4";
import {
  createOrderEditInputSchema,
  createOrderEditOutputSchema,
} from "./base";

/**
 * Schema for updating order items (add, remove, or change quantity)
 */

// Individual operation type that can be reused
const OrderOperation_ = z.object({
  variantId: z.string().describe("The variant ID to add or remove"),
  quantity: z.number().positive().describe("The quantity to add or remove"),
  action: z.enum(["add", "remove"]).describe("The action to perform"),
});

export const OrderOperationSchema: z.ZodType<OrderOperation> = OrderOperation_;
export interface OrderOperation extends z.infer<typeof OrderOperation_> {}

// Data schema for order items update
const UpdateOrderItemsData_ = z.object({
  operations: z
    .array(OrderOperationSchema)
    .describe("Array of operations to perform on the order"),
});

export const UpdateOrderItemsDataSchema: z.ZodType<UpdateOrderItemsData> =
  UpdateOrderItemsData_;
export interface UpdateOrderItemsData
  extends z.infer<typeof UpdateOrderItemsData_> {}

// Full input schema
const UpdateOrderItemsInput_ = createOrderEditInputSchema(
  UpdateOrderItemsDataSchema,
);

export const UpdateOrderItemsInput: z.ZodType<UpdateOrderItemsInput> =
  UpdateOrderItemsInput_;
export interface UpdateOrderItemsInput
  extends z.infer<typeof UpdateOrderItemsInput_> {}

// Output data schema - the result-specific fields
const UpdateOrderItemsOutputData_ = z.array(
  z.object({
    variantId: z.string(),
    action: z.enum(["add", "remove", "update"]),
    oldTotal: z.number(),
    newTotal: z.number(),
    quantity: z.number(),
    lineItemId: z.string().optional(),
    lineItemName: z.string().optional(),
    productTitle: z.string().optional(),
    variantTitle: z.string().optional(),
    sku: z.string().optional(),
  }),
);

export const UpdateOrderItemsOutputDataSchema: z.ZodType<UpdateOrderItemsOutputData> =
  UpdateOrderItemsOutputData_;
export interface UpdateOrderItemsOutputData
  extends z.infer<typeof UpdateOrderItemsOutputData_> {}

// Full output schema
const UpdateOrderItemsOutput_ = createOrderEditOutputSchema(
  UpdateOrderItemsOutputDataSchema,
);

export const UpdateOrderItemsOutput: z.ZodType<UpdateOrderItemsOutput> =
  UpdateOrderItemsOutput_;
export interface UpdateOrderItemsOutput
  extends z.infer<typeof UpdateOrderItemsOutput_> {}
